import { v4 as uuid } from 'uuid';
import type { CycleSessionInput, CycleSessionsResponse } from '@/api/cyclesService';

export const duplicateName = (name: string): string => `Copie de ${name}`;

export const duplicateIdentifier = (identifier: string, taken: string[]): string => {
  const used = new Set(taken);
  for (let i = 1; ; i += 1) {
    const candidate = `${identifier}_COPIE${i > 1 ? i : ''}`;
    if (!used.has(candidate)) return candidate;
  }
};

/**
 * Flattens the source cycle's grid into a save payload: the API returns `linkId`
 * for an enchaînement but expects a fresh `linkKey`, and weeks beyond the copy's
 * own bound would be rejected (SOURCE_WEEK_OUT_OF_RANGE).
 */
export const sessionsToInputs = (
  weeks: CycleSessionsResponse['weeks'],
  maxWeek: number
): CycleSessionInput[] => {
  const linkKeyById = new Map<string, string>();
  const inputs: CycleSessionInput[] = [];
  for (const week of weeks) {
    if (week.weekNumber > maxWeek) continue;
    for (const session of week.sessions) {
      let linkKey: string | null = null;
      if (session.linkId) {
        linkKey = linkKeyById.get(session.linkId) ?? uuid();
        linkKeyById.set(session.linkId, linkKey);
      }
      inputs.push({
        weekNumber: session.weekNumber,
        dayOfWeek: session.dayOfWeek,
        workoutId: session.workoutId,
        priorities: session.priorities.map((p) => ({ formatId: p.formatId, priority: p.priority })),
        linkKey,
      });
    }
  }
  return inputs;
};
